import { getCaseRunOptions, type RunDetailOut } from "@platform/api/golden";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { useGoldenClient } from "../api/GoldenClientProvider";
import { BACKGROUND_POLL_MS } from "../api/polling";

export const isRunGoing = (detail: RunDetailOut | undefined): boolean =>
  detail?.run.state === "queued" || detail?.run.state === "running";

/** One run of a case, asked again while it is going: a run is scored when it finishes. */
export const useCaseRun = (
  caseId: number,
  runId: number,
): UseQueryResult<RunDetailOut> => {
  const client = useGoldenClient();
  return useQuery({
    ...getCaseRunOptions({ client, path: { case_id: caseId, run_id: runId } }),
    refetchInterval: (query) =>
      isRunGoing(query.state.data) ? BACKGROUND_POLL_MS : false,
  });
};
